export enum MaintenanceStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}
